import { requiredNullish } from '@breezeventures/web-ph-validators/zod-utils';
import { z } from 'zod';

import { documentSchema } from './document-schema';

export const selfieSchema = z.object({
  document: requiredNullish(documentSchema, 'Photo is required'),
});

export type SelfieFormValues = z.infer<typeof selfieSchema>;
